export const getReceiptDateState = (receiptDate, asOf) => {
  const normalizedReceipt = String(receiptDate || '').slice(0, 10);
  const normalizedCutoff = String(asOf || '').slice(0, 10);
  if (!normalizedReceipt) {
    return {
      isMissing: true,
      isAfterCutoff: false,
    };
  }
  return {
    isMissing: false,
    isAfterCutoff: Boolean(
      normalizedCutoff && normalizedReceipt > normalizedCutoff
    ),
  };
};
